import React, { Fragment } from "react";
import Moment from "moment";
import { parseISO } from "date-fns";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Spinner } from "react-bootstrap";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import { ApiService } from "../../utils/ApiService";
import {
  Chips,
  TextInput,
  UploadSuccessMsg,
  CustomizeColumns,
  DeleteReport,
  DownloadReport,
} from "../../components";
import "../../App.css";
import { getMerchantId } from "../../utils/Helper";
import {
  NoReportsLogo,
  CustomizeLogo,
  PlainDeleteLogo,
  PlainEditLogo,
} from "../../assets/icons";
import AdhocInstructionsView from "../AdhocInstructionsView";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { REPORTS_PAGE_CONSTANTS } from "../../config/constants";
import { colors } from "../../config/colors";
import { TEXT_ALIGN_LEFT, DISPLAY_FLEX } from "../../config/styles";
import { ModalSyled } from "./styled";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

class ReportsView extends React.Component {
  constructor(props) {
    super(props);

    this.AdminType = localStorage.getItem("role");
    this.GenerateMsg = "Reports Generated Successfully";
    this.state = {
      reloadAdhocInstr: false,
      isReportTrigerred: false,
      isTimeout: false,
      isNetworking: false,
      snackMsg: this.GenerateMsg,
      showSnack: false,
      isCustomReport: true,
      isTransactionReport: false,
      selectAll: false,
      department: false,
      external: false,
      card: false,
      customer: false,
      deliveryDate: false,
      transaction: false,
      allCriteria: false,
      showCustomReport: false,
      pageNo: 0,
      pageSize: 10,
      TotalCount: "",
      loader: true,
      CustomReportCount: 1,
      isViewCustomReport: false,
      isEditCustomReport: false,
      isDeleteCustomReport: false,
      selectedDateTo: "",
      selectedDateFrom: "",
      selectedDateToApi: "",
      selectedDateFromApi: "",
      reportType: "",
      schoolAdmin: false,
      isColumnsChanged: false,
      downloadLink: "",
      allFieldsName: [],
      isFetching: false,
      SelectedCol: [],
      checked: false,
      customReportName: "",
      tabSelectvalue: 0,
      allCustomTemplate: [],
      allCustomTemplate_Loading: true,
      allCustomTemplateCount: 10,
      seteachCustom: "",
      isFromDateSelected: false,
      isToDateSelected: false,
      TemplateErrorMsg: "",
      isTemplateFound: false,
      templateId: "",
      showLink: false,
      view: false,
      superAdmin: "-1",
      generatedReportName: "",
    };
  }

  static propTypes = {
    onHideTabs: PropTypes.func.isRequired,
    onShowTabs: PropTypes.func.isRequired,
    tabSelection: PropTypes.string,
  };

  componentDidMount() {
    
    let role = localStorage.getItem("role");
    if (role == "SCHOOLADMIN") {
      this.setState({ schoolAdmin: true });
    }
  }

  getReportType = () =>
    this.state.isEditCustomReport
      ? this.state.seteachCustom.reportType
      : this.state.reportType === "Transaction Reports"
        ? "TRANSACTION"
        : this.state.reportType === "Convenience Fee Reports"
          ? "CONVENIENCE_FEE"
          : this.state.reportType === "Enrollment Reports"
          ? "ENROLLMENT"
          : this.state.reportType === "Student Registration Reports"
            ? "STUDENT_REGISTRATION"
            : this.state.reportType === "User Registration Reports"
              ? "USER_REGISTRATION"
              : this.state.reportType === "User Student Reports"
                ? "USER_STUDENT"
                : this.state.reportType === "Checkout Reports"
                  ? "CHECKOUT"
                  : null

  getTemplateName = () =>
    this.state.isEditCustomReport
      ? this.state.seteachCustom.templateName
      : this.state.customReportName

  getActualMerchantId = () => {
    return this.props.tabSelection === "MainLanding" ? null : getMerchantId();
  };

  handleFileDownload = async () => {
    let authCode = localStorage.getItem("bearer");
    let merchantId =
      this.props.tabSelection === "MainLanding" ? "-1" : getMerchantId();
    const url =
      API_URL.DOWNLOAD_REPORT +
      "?fileName=" +
      this.state.downloadLink +
      "&merchantId=" +
      merchantId;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: authCode,
        Accept: "application/json",
        merchantId: merchantId,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = this.state.downloadLink;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
      })
      .catch((err) => alert(err));
  };

  handleCustomModal = async () => {
    this.setState({ showCustomReport: true });
  };

  onCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnack: false });
  };

  onFetchAllTemplates = async () => {
    const url =
      API_URL.REPORT_GET_ALL_FIELDNAMES + this.state.seteachCustom.Type;
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };
  onTransactionReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Transaction Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "TRANSACTION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onTransactionReportsView = (item) => {
    this.setState({ isViewCustomReport: true, isCustomReport: false });
  };

  onConveniencFeeReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Convenience Fee Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "CONVENIENCE_FEE";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onEnrollmentReport = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Enrollment Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "ENROLLMENT";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onUserRegistrationReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "User Registration Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "USER_REGISTRATION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onUserStudentReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "User Student Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "USER_STUDENT";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onStudentRegistrationReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Student Registration Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "STUDENT_REGISTRATION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onCheckoutReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Checkout Reports",
        allFieldsName: [],
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "CHECKOUT";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  handleChange = async (event, newValue) => {
    this.setState(
      {
        isTimeout: false,
        tabSelectvalue: newValue,
        isTransactionReport: false,
        showSnack: false,
        showLink: false,
        downloadLink: "",
        generatedReportName: "",
        selectedDateTo: "",
        selectedDateFrom: "",
        selectedDateFromApi: "",
        selectedDateToApi: "",
        isFromDateSelected: false,
        isToDateSelected: false,
      },
      this.props.onShowTabs
    );
    if (this.state.tabSelectvalue === 1) {
      this.setState({ isViewCustomReport: false, isEditCustomReport: false });
    }
    let tabSelection = this.props.tabSelection;
    let url = "";
    if (newValue === 1) {
      let GlobalMerchantId = localStorage.getItem("globalMerchantId");
      let schoolAdminMerchantId = localStorage.getItem("schoolAdminMerchantId");
      if (tabSelection === "MainLanding") {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          "-1" +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      } else if (
        this.AdminType === ADMIN_TYPE.SUPERADMIN ||
        this.AdminType === ADMIN_TYPE.SALESADMIN
      ) {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          GlobalMerchantId +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      } else {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          schoolAdminMerchantId +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      }
      const resp = await ApiService.getRequest(url);
      if (resp && resp.status && resp.status.code === "Y") {
        this.setState({
          allCustomTemplate: resp.body,
          snackMsg: resp.status.message,
          isTemplateFound: true,
          allCustomTemplate_Loading: false,
        });
        this.setState({ TotalCount: parseInt(resp.status.message) });
      } else if (resp && resp.status && resp.status.code === "N") {
        this.setState({
          snackMsg:
            resp.status.message || "Something went wrong, Please Retry !!!",
          showSnack: true,
        });
      } else {
        this.setState({ isTemplateFound: true }, this.renderNoCustomReports());
        this.setState({ snackMsg: resp.status.message, showSnack: true });
      }
    }
  };

  onSaveCustomColumns = () => {
    this.setState({ isColumnsChanged: true, show: false });
    this.RefreshGrids();
  };
  handleCreateUser = async () => {
    this.setState({ show: true, showLink: false });
    if (this.state.isEditCustomReport) {
      const url =
        API_URL.REPORT_GET_ALL_FIELDNAMES + this.state.seteachCustom.reportType;
      const response = await ApiService.getRequest(url);
      if (!isEmpty(response)) {
        this.setState({ allFieldsName: response, isFetching: true });
      }
    }
  };
  backButton = () => {
    this.setState(
      {
        selectedDateTo: "",
        selectedDateFrom: "",
        showLink: false,
        isTransactionReport: false,
        isViewCustomReport: false,
        isEditCustomReport: false,
      },
      this.props.onShowTabs
    );
  };
  handleHide = () => {
    this.setState({ show: false });
    this.setState({ SelectedCol: [] });
  };
  onHideCustomModal = () => {
    this.setState({ showCustomReport: false, isDeleteCustomReport: false });
    this.setState({ isColumnsChanged: false });
  };
  onCustomNameChange = (event) => {
    this.setState({ customReportName: event.target.value });
  };

  reportTypeEnum = (type) => {
    switch (type) {
      case "Transaction Reports":
      case "TRANSACTION":
        return "TRANSACTION";
      case "Convenience Fee Reports":
      case "CONVENIENCE_FEE":
        return "CONVENIENCE_FEE";
      case "Student Registration Reports":
      case "STUDENT_REGISTRATION":
        return "STUDENT_REGISTRATION";
      case "User Registration Reports":
      case "USER_REGISTRATION":
        return "USER_REGISTRATION";
      case "User Student Reports":
      case "USER_STUDENT":
        return "USER_STUDENT";
      case "Enrollment Reports":
      case "ENROLLMENT":
        return "ENROLLMENT";
      case "Checkout Reports":
      case "CHECKOUT":
        return "CHECKOUT";
    }
  };

  onUpdateCustomModal = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.AdminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");

    try {
      let data = "";
      data = {
        headerList: this.state.SelectedCol,
        merchantId: merchantId,
        reportType: this.getReportType(),
        templateName: this.getTemplateName(),
      };
      const resp = await ApiService.postRequest(
        API_URL.REPORT_CUSTOM_UPDATE + this.state.seteachCustom.customReportId,
        data
      );

      if (resp.status && resp.status.code === "Y") {
        this.setState(
          {
            showCustomReport: false,
            isDeleteCustomReport: false,
            SelectedCol: [],
            showSnack: true,
            snackMsg: "Report Saved Successfully",
          },
          this.props.onShowTabs
        );
        this.setState({ isColumnsChanged: false, isEditCustomReport: false });
      } else {
        this.setState(
          {
            showCustomReport: false,
            isDeleteCustomReport: false,
            SelectedCol: [],
            showSnack: true,
            snackMsg: resp.status.message,
          },
          this.props.onShowTabs
        );
        this.setState({ isColumnsChanged: false, isEditCustomReport: false });
      }
    } catch (err) {
      this.setState({ showCustomReport: false, isDeleteCustomReport: false });
      this.setState(
        { isColumnsChanged: false, isEditCustomReport: false, SelectedCol: [] },
        this.props.onShowTabs
      );
    }
    this.handleRefresh();
  };

  onSaveCustomModal = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.AdminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");
    try {
      let data = "";
      data = {
        headerList: this.state.SelectedCol,
        merchantId: merchantId,
        reportType: this.getReportType(),
        templateName: this.getTemplateName(),
      };
      const resp = await ApiService.postRequest(
        API_URL.REPORT_CUSTOM_SAVE,
        data
      );
      if (resp.status && resp.status.code === "Y") {
        this.setState({ showCustomReport: false, isDeleteCustomReport: false });
        this.setState({
          isColumnsChanged: false,
          SelectedCol: [],
          customReportName: "",
          showSnack: true,
          snackMsg: "Custom Report Saved Successfully",
        });
      } else {
        this.setState({
          showCustomReport: false,
          isDeleteCustomReport: false,
          showSnack: true,
          snackMsg: resp.status.message,
        });
        this.setState({
          isColumnsChanged: false,
          SelectedCol: [],
          customReportName: "",
          showSnack: true,
          snackMsg: resp.status.message,
        });
      }
    } catch (err) {
      this.setState({ showCustomReport: false, isDeleteCustomReport: false });
      this.setState({
        isColumnsChanged: false,
        SelectedCol: [],
        customReportName: "",
        showSnack: true,
        snackMsg: err.status.message,
      });
    }
  };

  onCheckAllCriteria = () => {
    let allValue = false;
    allValue =
      this.state.selectAll &&
      this.state.department &&
      this.state.external &&
      this.state.card &&
      this.state.customer &&
      this.state.deliveryDate &&
      this.state.transaction;
    this.setState({ allCriteria: allValue });
  };

  handleShowEdit = () => {
    this.setState({ isEditCustomReport: true, isViewCustomReport: false });
  };

  handleShowDelete = () => {
    this.setState({ isDeleteCustomReport: true, isViewCustomReport: false });
  };
  onReset = () => {
    this.setState({ SelectedCol: [] });
  };

  onCheckAllCriteria = () => {
    this.setState({
      selectAll: !this.state.selectAll,
      department: !this.state.department,
      external: this.state.external,
      card: !this.state.card,
      customer: !this.state.customer,
      deliveryDate: !this.state.deliveryDate,
      transaction: !this.state.transaction,
    });
  };
  onDeleteCustomTemplate = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.AdminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");
    const url =
      API_URL.REPORT_CUSTOM_DELETE +
      merchantId +
      "/" +
      this.state.seteachCustom.customReportId;
    const response = await ApiService.deleteRequest(url);

    if (
      (response.error != undefined && response.error.status_code === 401) ||
      response.status === "403"
    ) {
      this.setState({ isDeleteCustomReport: false });
      return;
    }
    if (response.status.code == "Y") {
      this.setState({
        isDeleteCustomReport: false,
        snackMsg: response.status.message,
        showSnack: true,
      });
      this.handleRefresh();
    }
  };
  async handleRefresh() {
    this.setState({ allCustomTemplate_Loading: true });
    this.setState({
      reloadAdhocInstr: false,
      isTimeout: false,
      isTransactionReport: false,
      showSnack: false,
      showLink: false,
      downloadLink: "",
      generatedReportName: "",
      selectedDateTo: "",
      selectedDateFrom: "",
      selectedDateFromApi: "",
      selectedDateToApi: "",
      isFromDateSelected: false,
      isToDateSelected: false,
    });
    let GlobalMerchantId = localStorage.getItem("globalMerchantId");
    let schoolAdminMerchantId = localStorage.getItem("schoolAdminMerchantId");
    let tabSelection = this.props.tabSelection;
    let url = "";
    if (tabSelection === "MainLanding") {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        "-1" +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    } else if (
      this.AdminType === ADMIN_TYPE.SUPERADMIN ||
      this.AdminType === ADMIN_TYPE.SALESADMIN
    ) {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        GlobalMerchantId +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    } else {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        schoolAdminMerchantId +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    }
    const resp = await ApiService.getRequest(url);
    if (resp && resp.status && resp.status.code === "Y") {
      this.setState({
        allCustomTemplate: resp.body,
        isTemplateFound: true,
        allCustomTemplate_Loading: false,
      });
      this.setState({ TotalCount: parseInt(resp.status.message) });
    } else {
      this.setState({ isTemplateFound: false });
    }
  }
  getName = (type) => {
    let Name =
      type === "TRANSACTION"
        ? "Transaction_Custom_Report"
        : type === "CONVENIENCE_FEE"
          ? "Convenience_Fee_Custom_Report"
          : type === "ENROLLMENT"
          ? "Enrollment_Report"
          : type === "STUDENT_REGISTRATION"
            ? "Student_Registration_Custom_Report"
            : type === "USER_REGISTRATION"
              ? "User_Registration_Custom_Reports"
              : type === "USER_STUDENT"
                ? "User_Student_Custom_Reports"
                : null;
    return Name;
  };
  handleCustomGenerateReport = async () => {
    this.setState({ isReportTrigerred: true, reloadAdhocInstr: false });
    let tabSelection = this.props.tabSelection;
    const roleData = localStorage.getItem("role");
    let merchantId = "";
    if (roleData === ADMIN_TYPE.SUPERADMIN) {
      merchantId = localStorage.getItem("globalMerchantId");
    }
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      merchantId = localStorage.getItem("schoolAdminMerchantId");
    }
    if (roleData === ADMIN_TYPE.SALESADMIN) {
      merchantId = localStorage.getItem("globalMerchantId");
    }
    try {
      let data = "";
      let resp = "";
      data = {
        fromDate: this.state.selectedDateFromApi,
        reportTemplateName: this.getName(this.state.seteachCustom.reportType),
        toDate: this.state.selectedDateToApi,
        type: this.state.seteachCustom.reportType,
        reportHeaderList: this.state.seteachCustom.headerList,
        customReportId: this.state.seteachCustom.customReportId,
      };
      if (tabSelection === "MainLanding") {
        resp = await ApiService.postRequest(
          API_URL.REPORT_TRANSACTION_CUSTOM,
          data
        );
      } else {
        resp = await ApiService.postRequest(
          API_URL.REPORT_TRANSACTION_CUSTOM + merchantId,
          data
        );
      }

      if (resp.status === 504) {
        this.setState({
          isReportTrigerred: false,
          showSnack: false,
          showLink: false,
          isTimeout: true,
          isNetworking: false,
          reloadAdhocInstr: true,
        });
        return;
      }

      if (resp.status && resp.status.code === "Y") {
        this.setState({
          reloadAdhocInstr: true,
          isReportTrigerred: false,
          isTimeout: false,
          showSnack: true,
          snackMsg: this.GenerateMsg,
          downloadLink: resp.status.message,
          generatedReportName: resp.body,
          showLink: true,
        });
      } else {
        this.setState({
          isReportTrigerred: false,
          isTimeout: false,
          isNetworking: false,
          snackMsg: resp.status.message || "Failed to generate report. ",
          showSnack: true,
          showLink: false,
        });
      }
    } catch (err) {
      this.setState({
        isReportTrigerred: false,
        isNetworking: false,
        showLink: false,
      });
    }
  };

  handleGenerateReport = async () => {
    this.setState({ isReportTrigerred: true, reloadAdhocInstr: false });
    let tabSelection = this.props.tabSelection;
    const roleData = localStorage.getItem("role");
    let merchantId = "";
    if (roleData === ADMIN_TYPE.SUPERADMIN) {
      merchantId = localStorage.getItem("globalMerchantId");
    }
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      merchantId = localStorage.getItem("schoolAdminMerchantId");
    }
    if (roleData === ADMIN_TYPE.SALESADMIN) {
      merchantId = localStorage.getItem("globalMerchantId");
    }
    try {
      let data = "";
      let resp = "";
      if (this.state.isColumnsChanged && this.state.SelectedCol.length > 0) {
        data = {
          fromDate: this.state.selectedDateFromApi,
          reportTemplateName:
            this.state.reportType === "Transaction Reports"
              ? "Transaction_Standard_Report"
              : this.state.reportType === "Convenience Fee Reports"
              ? "Convenience_Fee_Standard_Report"
                : this.state.reportType === "Enrollment Reports"
                ? "Enrollment Report"
                : this.state.reportType === "Student Registration Reports"
                  ? "Student_Registration_Standard_Report"
                  : this.state.reportType === "User Registration Reports"
                    ? "User_Registration_Standards_Reports"
                    : this.state.reportType === "User Student Reports"
                      ? "User_Student_Standards_Reports"
                      : this.state.reportType === "Checkout Reports"
                        ? "Checkout_Standard_Report"
                        : null,
          toDate: this.state.selectedDateToApi,
          type:
            this.state.reportType === "Transaction Reports"
              ? "TRANSACTION"
              : this.state.reportType === "Convenience Fee Reports"
                ? "CONVENIENCE_FEE"
                : this.state.reportType === "Enrollment Reports"
                ? "ENROLLMENT"
                : this.state.reportType === "Student Registration Reports"
                  ? "STUDENT_REGISTRATION"
                  : this.state.reportType === "User Registration Reports"
                    ? "USER_REGISTRATION"
                    : this.state.reportType === "User Student Reports"
                      ? "USER_STUDENT"
                      : this.state.reportType === "Checkout Reports"
                        ? "CHECKOUT"
                        : null,
          reportHeaderList: this.state.SelectedCol,
        };
      } else {
        data = {
          fromDate: this.state.selectedDateFromApi,
          reportTemplateName:
            this.state.reportType === "Transaction Reports"
              ? "Transaction_Standard_Report"
              : this.state.reportType === "Convenience Fee Reports"
                ? "Convenience_Fee_Standard_Report"
                : this.state.reportType === "Enrollment Reports"
                ? "Enrollment Report"
                : this.state.reportType === "Student Registration Reports"
                  ? "Student_Registration_Standard_Report"
                  : this.state.reportType === "User Registration Reports"
                    ? "User_Registration_Standards_Reports"
                    : this.state.reportType === "User Student Reports"
                      ? "User_Student_Standards_Reports"
                      : this.state.reportType === "Checkout Reports"
                        ? "Checkout_Standard_Report"
                        : null,
          toDate: this.state.selectedDateToApi,
          type:
            this.state.reportType === "Transaction Reports"
              ? "TRANSACTION"
              : this.state.reportType === "Convenience Fee Reports"
                ? "CONVENIENCE_FEE"
                : this.state.reportType === "Enrollment Reports"
                ? "ENROLLMENT"
                : this.state.reportType === "Student Registration Reports"
                  ? "STUDENT_REGISTRATION"
                  : this.state.reportType === "User Registration Reports"
                    ? "USER_REGISTRATION"
                    : this.state.reportType === "User Student Reports"
                      ? "USER_STUDENT"
                      : this.state.reportType === "Checkout Reports"
                        ? "CHECKOUT"
                        : null,
        };
      }
      if (tabSelection === "MainLanding") {
        if (this.state.isColumnsChanged && this.state.SelectedCol.length > 0) {
          resp = await ApiService.postRequest(
            API_URL.REPORT_TRANSACTION_CUSTOM,
            data
          );
        } else {
          resp = await ApiService.postRequest(
            API_URL.REPORT_TRANSACTION_STANDARD,
            data
          );
        }
      } else if (
        this.state.isColumnsChanged &&
        this.state.SelectedCol.length > 0
      ) {
        resp = await ApiService.postRequest(
          API_URL.REPORT_TRANSACTION_CUSTOM + merchantId,
          data
        );
      } else {
        resp = await ApiService.postRequest(
          API_URL.REPORT_TRANSACTION_STANDARD + merchantId,
          data
        );
      }

      if (resp.status === 504) {
        this.setState({
          showSnack: false,
          showLink: false,
          isTimeout: true,
          isNetworking: false,
          isReportTrigerred: false,
          reloadAdhocInstr: true,
        });
        return;
      }

      if (resp.status && resp.status.code === "Y") {
        this.setState({
          reloadAdhocInstr: true,
          isReportTrigerred: false,
          isTimeout: false,
          isNetworking: false,
          showSnack: true,
          snackMsg: this.GenerateMsg,
          downloadLink: resp.status.message,
          generatedReportName: resp.body,
          showLink: true,
        });
      } else {
        this.setState({
          isReportTrigerred: false,
          isTimeout: false,
          isNetworking: false,
          snackMsg: resp.status.message,
          showSnack: true,
          showLink: false,
        });
      }
    } catch (err) {
      this.setState({
        isReportTrigerred: false,
        isNetworking: false,
        showLink: false,
      });
    }
  };

  handleToDateChange = (date) => {
    let toDateString = Moment(date).format("YYYY-MM-DD");
    this.setState({
      selectedDateToApi: toDateString + "T23:59:59",
      selectedDateTo: toDateString,
      isToDateSelected: date === null ? false : true,
    });
  };
  handleFromDateChange = (date) => {
    let fromDateString = Moment(date).format("YYYY-MM-DD");
    this.setState({
      selectedDateFromApi: fromDateString + "T00:00:00",
      selectedDateFrom: fromDateString,
      isFromDateSelected: date === null ? false : true,
    });
  };

  RefreshGrids = () => {
    const columnChips =
      this.state.isColumnsChanged && this.state.SelectedCol.length > 0
        ? this.state.SelectedCol
        : this.state.allFieldsName;
    return (
      <div>
        <Grid container style={{ display: "flexGrow", margin: 10 }} spacing={1}>
          {columnChips.map((item) => (
            <Grid item spacing={2}>
              <Chips className="column_chips" disabled label={item} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  };

  renderNoCustomReports = () => {
    return (
      <div className="d-flex flex-column w-100 h-100 gap-3 justify-content-center align-items-center mt-5">
        <NoReportsLogo />
        <Typography variant="body1">
          You have not created any custom reports
        </Typography>
      </div>
    );
  };

  renderCustomReports = () => {
    return (
      <div className="w-100 my-3">
        {this.state.isTemplateFound ? (
          <Fragment>
            <Typography sx={{ textAlign: TEXT_ALIGN_LEFT }} variant="h5">
              Custom Reports
            </Typography>
            <div className="d-flex gap-3 flex-wrap py-4 w-100 justify-content-between">
              {this.state.allCustomTemplate.map((item) => (
                <div className="custom-card-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        width: "70%",
                        overflow: "hidden",
                      }}
                      onClick={() =>
                        this.setState(
                          {
                            isViewCustomReport: true,
                            isCustomReport: false,
                            seteachCustom: item,
                          },
                          this.props.onHideTabs
                        )
                      }
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          color: colors.primary,
                          textAlign: TEXT_ALIGN_LEFT,
                        }}
                      >
                        {item.templateName}
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          color: colors.grayLight,
                          textAlign: TEXT_ALIGN_LEFT,
                        }}
                      >
                        {item.reportType}
                      </Typography>
                    </button>
                    <div className="d-flex flex-row gap-2">
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        onClick={() =>
                          this.setState({
                            isDeleteCustomReport: true,
                            isViewCustomReport: false,
                            seteachCustom: item,
                          })
                        }
                      >
                        <PlainDeleteLogo />
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        onClick={() =>
                          this.setState(
                            {
                              isEditCustomReport: true,
                              isViewCustomReport: false,
                              seteachCustom: item,
                            },
                            this.props.onHideTabs
                          )
                        }
                      >
                        <PlainEditLogo />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        ) : (
          <Typography variant="h5">{this.state.TemplateErrorMsg}</Typography>
        )}
      </div>
    );
  };
  renderGenerateReport = () => {
    const standardColumns = this.state.allFieldsName || [];
    return (
      <Fragment>
        <div className="view-report-container w-100 pb-4">
          <Typography variant="h5" className="pb-4">
            Report type
          </Typography>
          <Form.Floating
            as={Row}
            className="mb-3 mx-1 w-100"
            controlId=""
            key="Type"
          >
            <Form.Control
              type="text"
              autocomplete="off"
              value={this.state.reportType}
              disabled={true}
              className="disabled-form-input"
            />
            <label>Type</label>
          </Form.Floating>
        </div>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Select Period
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="d-flex flex-row w-100 gap-3">
              <DatePicker
                slotProps={{
                  textField: {
                    variant: "outlined",
                    margin: "normal",
                    helperText: "",
                  },
                }}
                disableFuture
                format="dd/MM/yyyy"
                label="Start date"
                value={
                  this.state.selectedDateFrom
                    ? parseISO(this.state.selectedDateFrom)
                    : null
                }
                onChange={this.handleFromDateChange}
              />

              <DatePicker
                slotProps={{
                  textField: {
                    variant: "outlined",
                    margin: "normal",
                    helperText: "",
                  },
                }}
                disableFuture
                label="End date"
                format="dd/MM/yyyy"
                value={
                  this.state.selectedDateTo
                    ? parseISO(this.state.selectedDateTo)
                    : null
                }
                onChange={this.handleToDateChange}
              />
            </div>
          </LocalizationProvider>
        </div>
        <div className="view-report-container">
          <div className="d-flex justify-content-between align-items-center w-100 p-2">
            <Typography variant="h5" className="pb-4">
              Customize Columns
            </Typography>
            <Button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: colors.primary,
                display: DISPLAY_FLEX,
              }}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
              onClick={this.handleCreateUser}
            >
              <PlainEditLogo />
              <Typography sx={{ marginLeft: 1 }} variant="body1">
                Edit
              </Typography>
            </Button>
          </div>
          <div className="d-flex flex-row w-100">
            {this.state.isFetching ? (
              this.RefreshGrids()
            ) : (
              <div
                style={{
                  alignSelf: "center",
                  padding: 16,
                  marginLeft: "45%",
                  marginTop: "5%",
                }}
              >
                <CircularProgress size={24} thickness={5} />
              </div>
            )}
          </div>
        </div>
        <div className="view-report-container d-flex flex-row gap-3">
          {this.state.isColumnsChanged && this.state.SelectedCol.length > 0 ? (
            <Button
              className="cancel-button w-100"
              onClick={this.handleCustomModal}
            >
              Save As Custom Report
            </Button>
          ) : null}
          {this.state.isNetworking ? (
            <Button
              className="cancel-button w-100"
              onClick={this.handleCustomModal}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            className="generate-button w-100"
            onClick={this.handleGenerateReport}
            disabled={
              !this.state.isFromDateSelected ||
              !this.state.isToDateSelected ||
              this.state.selectedDateFrom < 1 ||
              this.state.selectedDateTo < 1 ||
              this.state.isReportTrigerred
            }
            isLoading={this.state.isNetworking}
          >
            {this.state.isReportTrigerred ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              <span>Generate</span>
            )}
          </Button>
        </div>
        {(this.state.showLink || this.state.isTimeout) && (
          <UploadSuccessMsg msg="Report submitted for processing, download report below" />
        )}
      </Fragment>
    );
  };

  renderViewReportType = () => {
    return (
      <Fragment>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Report type
          </Typography>
          <div className="d-flex flex-column align-items-start gap-2">
            <Typography variant="h4" sx={{ color: colors.nonActive }}>
              Custom Report Name
            </Typography>
            <Typography
              variant="subtitle2"
              className="pb-3"
              sx={{ color: colors.custom }}
            >
              {this.state.seteachCustom.templateName}
            </Typography>
            <Typography variant="h4" sx={{ color: colors.nonActive }}>
              Report Type
            </Typography>
            <Typography
              variant="subtitle2"
              className="pb-3"
              sx={{ color: colors.custom }}
            >
              CUSTOM
            </Typography>
            <Typography variant="h4" sx={{ color: colors.nonActive }}>
              Report Name
            </Typography>
            <Typography
              variant="subtitle2"
              className="pb-3"
              sx={{ color: colors.custom }}
            >
              {this.state.seteachCustom.reportType}
            </Typography>
          </div>
        </div>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Select Period
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="d-flex flex-row w-100 gap-3">
              <DatePicker
                slotProps={{
                  textField: {
                    variant: "outlined",
                    margin: "normal",
                    helperText: "",
                  },
                }}
                disableFuture
                format="dd/MM/yyyy"
                label="Start date"
                value={
                  this.state.selectedDateFrom
                    ? parseISO(this.state.selectedDateFrom)
                    : null
                }
                onChange={this.handleFromDateChange}
              />

              <DatePicker
                slotProps={{
                  textField: {
                    variant: "outlined",
                    margin: "normal",
                    helperText: "",
                  },
                }}
                disableFuture
                label="End date"
                format="dd/MM/yyyy"
                value={
                  this.state.selectedDateTo
                    ? parseISO(this.state.selectedDateTo)
                    : null
                }
                onChange={this.handleToDateChange}
              />
            </div>
          </LocalizationProvider>
        </div>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Columns
          </Typography>
          <div className="d-flex flex-row w-100">
            <Grid
              container
              style={{ display: "flexGrow", margin: 10 }}
              spacing={1}
            >
              {this.state.seteachCustom.headerList.map((item) => (
                <Grid item spacing={2}>
                  <Chips className="column_chips" disabled label={item} />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
        <div className="view-report-container">
          <Button
            className="generate-button w-100"
            onClick={this.handleCustomGenerateReport}
            disabled={
              !this.state.isFromDateSelected || !this.state.isToDateSelected
            }
          >
            {this.state.isReportTrigerred ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              <span>Generate</span>
            )}
          </Button>
        </div>
      </Fragment>
    );
  };

  renderCustomModal() {
    return (
      <ModalSyled
        centered
        show={this.state.showCustomReport}
        onHide={this.onHideCustomModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Custom Report Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please provide the below information to save the report. You can view
          / edit the custom reports on the Reports page.
          <TextInput
            label="Custom Report Name"
            value={this.state.customReportName}
            disabled={false}
            onChange={this.onCustomNameChange}
            style={{ width: "100%", margin: "1rem auto 0 auto" }}
          />
        </Modal.Body>
        <div className="d-flex flex-row justify-content-between gap-3 p-4">
          <Button
            className="cancel-button w-100"
            onClick={this.onHideCustomModal}
          >
            Cancel
          </Button>
          <Button
            className="generate-button w-100"
            onClick={this.onSaveCustomModal}
            disabled={
              this.state.customReportName.trim().replace(/\s+/g, "").length < 1
            }
          >
            Save As Custom Report
          </Button>
        </div>
      </ModalSyled>
    );
  }

  renderCreateUserModal() {
    return (
      <CustomizeColumns
        show={this.state.show}
        handleHide={this.handleHide}
        handleSave={this.onSaveCustomColumns}
        onChange={(item) => this.setState({ SelectedCol: item })}
        allFieldsName={this.state.allFieldsName}
        selectedFields={this.state.SelectedCol}
      />
    );
  }

  renderEditCustomView() {
    const editViewColumns =
      this.state.SelectedCol.length > 0
        ? this.state.SelectedCol
        : this.state.seteachCustom.headerList;
    return (
      <Fragment>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Report type
          </Typography>
          <div className="d-flex flex-column align-items-start gap-3 w-100 pb-3">
            <TextInput
              label="Custom Report Name"
              value={this.state.seteachCustom.templateName}
              disabled={true}
              className="w-100"
            />

            <TextInput
              label="Report Name"
              value={this.state.seteachCustom.reportType}
              disabled={true}
              className="w-100"
            />
          </div>
        </div>
        <div className="view-report-container">
          <div className="d-flex flex-row justify-content-between pb-4 w-100">
            <Typography variant="h5">Customize Columns</Typography>
            <button
              style={{ background: "transparent", border: "none" }}
              className="d-flex flex-row cursor-pointer"
              onClick={this.handleCreateUser}
            >
              <CustomizeLogo />
              <Typography variant="body1" sx={{ color: colors.primary }}>
                Edit
              </Typography>
            </button>
          </div>

          <div className="d-flex flex-row w-100">
            <Grid
              container
              style={{ display: "flexGrow", margin: 10 }}
              spacing={1}
            >
              {editViewColumns.map((item) => (
                <Grid item spacing={2}>
                  <Chips className="column_chips" disabled label={item} />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between gap-3 pt-5">
          <Button
            className="cancel-button w-100"
            onClick={() =>
              this.setState(
                { isEditCustomReport: false, SelectedCol: [] },
                this.props.onShowTabs
              )
            }
          >
            Cancel
          </Button>
          <Button
            className="generate-button w-100"
            onClick={this.onUpdateCustomModal}
            disabled={this.state.SelectedCol.length < 1}
          >
            Save As Custom Report
          </Button>
        </div>
      </Fragment>
    );
  }
  renderDeleteCustomView() {
    return (
      <DeleteReport
        show={this.state.isDeleteCustomReport}
        onHide={this.onHideCustomModal}
        title={"Delete Custom Report"}
        onDone={this.onDeleteCustomTemplate}
      />
    );
  }
  renderDeleteEdit() {
    return (
      <div
        className="d-flex flex-row gap-2"
        style={{ marginTop: -70, float: "right" }}
      >
        <Button
          className="tab-button"
          onClick={() => {
            this.handleShowDelete();
            this.setState(
              {
                isDeleteCustomReport: true,
                isViewCustomReport: false,
              },
              this.props.onShowTabs
            );
          }}
        >
          {REPORTS_PAGE_CONSTANTS.BUTTON_DELETE}
        </Button>
        <Button
          className="tab-button"
          onClick={() =>
            this.setState({
              isEditCustomReport: true,
              isViewCustomReport: false,
            })
          }
        >
          {REPORTS_PAGE_CONSTANTS.BUTTON_EDIT}
        </Button>
      </div>
    );
  }

  renderViewStandard() {
    const roleData = localStorage.getItem("role");
    return (
      <div className="w-100 my-3">
        <Typography sx={{ textAlign: TEXT_ALIGN_LEFT }} variant="h5">
          View Standard Reports
        </Typography>
        <div className="d-flex gap-3 flex-wrap py-4 w-100 justify-content-start">
          <div className="card-container">
            <Typography
              variant="h5"
              sx={{ color: colors.primary }}
              onClick={this.onTransactionReports}
            >
              Transaction Reports
            </Typography>
            <Typography variant="h4" sx={{ color: colors.grayLight }}>
              Product and bank reconcilliation details
            </Typography>
          </div>

          {roleData === ADMIN_TYPE.SUPERADMIN && (
            <div className="card-container">
              <Typography
                variant="h5"
                sx={{ color: colors.primary }}
                onClick={this.onConveniencFeeReports}
              >
                Convenience Fee Report
              </Typography>
              <Typography variant="h4" sx={{ color: colors.grayLight }}>
                Convenince Fee Details
              </Typography>
            </div>
          )}


            <div className="card-container">
              <Typography
                variant="h5"
                sx={{ color: colors.primary }}
                onClick={this.onEnrollmentReport}
              >
                Enrollment Report
              </Typography>
              <Typography variant="h4" sx={{ color: colors.grayLight }}>
                Enrollment Report
              </Typography>
            </div>


          <div className="card-container">
            <Typography
              variant="h5"
              sx={{ color: colors.primary }}
              onClick={this.onCheckoutReports}
            >
              Checkout Reports
            </Typography>
            <Typography variant="h4" sx={{ color: colors.grayLight }}>
              Checkout transaction details
            </Typography>
          </div>

          {this.props.tabSelection === "MainLanding" ? (
            <Fragment>
              <div className="card-container">
                <Typography
                  variant="h5"
                  sx={{ color: colors.primary }}
                  onClick={this.onUserRegistrationReports}
                >
                  User Registration Reports
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grayLight }}>
                  Complete list of standalone users
                </Typography>
              </div>

              <div className="card-container">
                <Typography
                  variant="h5"
                  sx={{ color: colors.primary }}
                  onClick={this.onUserStudentReports}
                >
                  User/Student Reports
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grayLight }}>
                  User/Student registration details
                </Typography>
              </div>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.isViewCustomReport ? this.renderDeleteEdit() : null}
        <div>
          <div>
            <Tabs
              value={this.state.tabSelectvalue}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleChange}
              aria-label="disabled tabs example"
            >
              <Tab label="Standard" {...a11yProps(0)} />
              <Tab label="Custom" {...a11yProps(1)} />
            </Tabs>
            <TabPanel
              value={this.state.tabSelectvalue}
              index={0}
              className="w-100"
            >
              <div className="d-flex w-100 flex-column gap-3">
                {this.state.isTransactionReport
                  ? this.renderGenerateReport()
                  : this.renderViewStandard()}
              </div>

              <div>
                {this.state.isTransactionReport && (
                  <AdhocInstructionsView
                    reload={this.state.reloadAdhocInstr}
                    reportConfig={{
                      reportCategory: "STANDARD",
                      reportType: this.reportTypeEnum(this.state.reportType),
                      merchantId: this.getActualMerchantId(),
                    }}
                  />
                )}
              </div>
            </TabPanel>
            <TabPanel value={this.state.tabSelectvalue} index={1}>
              <div className="d-block">
                <div className="custom-report-header">
                  {this.state.TotalCount === 0
                    ? this.renderNoCustomReports()
                    : this.state.isViewCustomReport
                      ? this.renderViewReportType()
                      : this.state.isEditCustomReport
                        ? this.renderEditCustomView()
                        : this.renderCustomReports()}
                </div>
              </div>
              {this.state.isViewCustomReport && (
                <AdhocInstructionsView
                  reload={this.state.reloadAdhocInstr}
                  reportConfig={{
                    reportCategory: "CUSTOM",
                    reportType: this.reportTypeEnum(
                      this.state.seteachCustom.reportType
                    ),
                    customReportId: this.state.seteachCustom.customReportId,
                    merchantId: this.getActualMerchantId(),
                  }}
                />
              )}
            </TabPanel>
          </div>
          <DownloadReport
            show={this.state.showSnack}
            onHide={this.onCloseSnack}
            title={this.state.snackMsg}
            message={
              this.state.tabSelectvalue === 0
                ? "Transaction report with product and bank reconciliation details successfully generated"
                : "Custom report with product and bank reconciliation details successfully generated"
            }
            handleSave={
              this.state.showCustomReport ? null : this.handleFileDownload
            }
          />
        </div>
        {this.renderCreateUserModal()}
        {this.renderCustomModal()}
        {this.renderDeleteCustomView()}
      </div>
    );
  }
}

export default ReportsView;
